import React, { useEffect, useState } from 'react';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  IconButton,
  Drawer,
  Divider,
  useTheme,
  Toolbar,
  Typography,
  List,
  ListItem,
  Menu,
  MenuItem,
  Button,
} from '@material-ui/core';

import { FaCaretDown } from 'react-icons/fa';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useStyle, drawerStyles } from './styles';
import LogoWhite from '../../assets/logo2.svg';
import GovLogo from '../../assets/gov-logo.svg';
import ModalCarousel from '../ModalCarousel/index';
import Colors from '../Colors';

const Navbar: React.FC = () => {
  const location = useLocation();

  const styles = useStyle();
  const dStyles = drawerStyles();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const history = useHistory();

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [education, setEducation] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [active, setActive] = useState<number>(1);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorIncidents, setAnchorIncidents] = useState(null);
  const [anchorIncidentsSAMU, setAnchorIncidentsSAMU] = useState(null);
  const [anchorEngineering, setAnchorEngineering] = useState(null);
  const [anchorSurveillance, setAnchorSurveillance] = useState(null);
  const [anchorEducation, setAnchorEducation] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickIncidents = (event: any) => {
    setAnchorIncidents(event.currentTarget);
  };
  const handleCloseIncidents = () => {
    setAnchorIncidents(null);
  };
  const handleClickIncidentsSAMU = (event: any) => {
    setAnchorIncidentsSAMU(event.currentTarget);
  };
  const handleCloseIncidentsSAMU = () => {
    setAnchorIncidentsSAMU(null);
  };
  const handleClickEngineering = (event: any) => {
    setAnchorEngineering(event.currentTarget);
  };
  const handleCloseEngineering = () => {
    setAnchorEngineering(null);
  };
  const handleClickSurveillance = (event: any) => {
    setAnchorSurveillance(event.currentTarget);
  };
  const handleClickEducation = (event: any) => {
    setAnchorEducation(event.currentTarget);
  };
  const handleCloseSurveillance = () => {
    setAnchorSurveillance(null);
  };
  const handleCloseEducation = () => {
    setAnchorEducation(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth');
    localStorage.removeItem('id');
    history.push('/');
    window.location.reload();
  };

  useEffect(() => {
    if (location) {
      const nameRoute = location.pathname.split('/')[1];
      const registerRoute = location.pathname.split('/')[2];

      if (registerRoute === 'sinistros' || registerRoute === 'sinistro') {
        setActive(1);
      }
      if (registerRoute === 'sinistroSAMU' || registerRoute === 'sinistrosSAMU') {
        setActive(6);
      }
      if (registerRoute === 'engenharias' || registerRoute === 'engenharia') {
        setActive(2);
      }
      if (registerRoute === 'fiscalizacoes' || registerRoute === 'fiscalizacao') {
        setActive(3);
      }
      if (registerRoute === 'educacao' || registerRoute === 'educ') {
        setActive(7);
      }
      if (nameRoute === 'gerencia') {
        setActive(4);
      }
      if (nameRoute === 'minhaconta') {
        setActive(5);
      }
    }

    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'educacao') {
          setEducation(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, [location]);

  return (
    <>
      <AppBar className={styles.appBar} position="fixed">
        <Toolbar>
          {localStorage.getItem('auth') ? (
            <IconButton
              className={styles.menuButton}
              onClick={handleDrawerOpen}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
          ) : (
            false
          )}
          {localStorage.getItem('auth') ? (
            <>
              <Box className={styles.appBarGrid}>
                {/* <img src={LogoWhite} alt="Logo VIDA" className={styles.logo} /> */}

                <Button
                  className={active === 1 ? styles.active : styles.button2}
                  onClick={(e) => {
                    handleClickIncidents(e);
                  }}
                >
                  Sinistros
                  {/* <FaCaretDown style={{ fontSize: '16px', marginLeft: '5%' }} /> */}
                </Button>

                {!(tecEng || geofi || typist || publicGroup || education) && admin ? (
                  <Button
                    className={active === 6 ? styles.active : styles.button2}
                    onClick={(e) => {
                      handleClickIncidentsSAMU(e);
                    }}
                  >
                    Samu
                    {/* <FaCaretDown style={{ fontSize: '25px', marginLeft: '5%' }} /> */}
                  </Button>
                ) : (
                  false
                )}

                {(publicGroup || education) && !(admin || typist || tecEng || geofi) ? (
                  false
                ) : (
                  <Button
                    className={active === 2 ? styles.active : styles.button2}
                    onClick={(e) => {
                      handleClickEngineering(e);
                    }}
                  >
                    Engenharia
                    {/* <FaCaretDown style={{ fontSize: '25px', marginLeft: '5%' }} /> */}
                  </Button>
                )}

                {(publicGroup || tecEng || education) && !(admin || typist || geofi) ? (
                  false
                ) : (
                  <Button
                    className={active === 3 ? styles.active : styles.button2}
                    onClick={(e) => {
                      handleClickSurveillance(e);
                    }}
                  >
                    Fiscalização
                    {/* <FaCaretDown style={{ fontSize: '25px', marginLeft: '5%' }} /> */}
                  </Button>
                )}

                {admin || education ? (
                  <Button
                    className={active === 7 ? styles.active : styles.button2}
                    onClick={(e) => {
                      handleClickEducation(e);
                    }}
                  >
                    Educação
                    {/* <FaCaretDown style={{ fontSize: '25px', marginLeft: '5%' }} /> */}
                  </Button>
                ) : (
                  false
                )}

                {(tecEng || geofi || typist || publicGroup || education) && !admin ? (
                  false
                ) : (
                  <div>
                    <Link to="/gerencia" style={{ textDecoration: 'none' }}>
                      <Button
                        className={active === 4 ? styles.active : styles.button2}
                        onClick={() => setActive(4)}
                      >
                        Gerência
                      </Button>
                    </Link>
                  </div>
                )}

                <Link
                  to="/acessarboletim/access"
                  target="black"
                  style={{ textDecoration: 'none' }}
                >
                  <Button className={styles.buttonInverted}>Boletim</Button>
                </Link>
              </Box>
              <Box className={styles.boxButton}>
                <img
                  src={GovLogo}
                  alt="Logo Prefeitura de Fortaleza"
                  className={styles.govLogo}
                />

                <Button
                  className={active === 5 ? styles.active : styles.button4}
                  onClick={(e) => {
                    handleClick(e);
                  }}
                >
                  Minha conta
                  <MoreVertIcon />
                </Button>
              </Box>

              {/* <ModalCarousel /> */}
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={styles.menuAccount}
              >
                <Link to="/minhaconta">
                  <MenuItem
                    onClick={handleClose}
                    className={active === 4 ? styles.active : styles.menuItemAccount}
                  >
                    Meus dados
                  </MenuItem>
                </Link>
                <MenuItem onClick={handleLogout} className={styles.menuItemAccount}>
                  Sair
                </MenuItem>
              </Menu>

              <Menu
                id="simple-menu"
                anchorEl={anchorIncidents}
                keepMounted
                open={Boolean(anchorIncidents)}
                onClose={handleCloseIncidents}
                className={styles.menuRegisters}
              >
                <NavLink to="/mapa/sinistros" activeStyle={{ color: Colors.main }}>
                  <MenuItem
                    onClick={() => {
                      handleCloseIncidents();
                      setActive(1);
                    }}
                    className={styles.menuItemMap}
                  >
                    Mapa
                  </MenuItem>
                </NavLink>
                <NavLink to="/painel" activeStyle={{ color: Colors.main }}>
                  <MenuItem
                    onClick={() => {
                      handleCloseIncidents();
                      setActive(1);
                    }}
                    className={styles.menuItemMap}
                  >
                    Painel
                  </MenuItem>
                </NavLink>
                <NavLink to="/registros/sinistros" activeStyle={{ color: Colors.main }}>
                  <MenuItem
                    onClick={() => {
                      handleCloseIncidents();
                      setActive(1);
                    }}
                    className={styles.menuItemMap}
                  >
                    Registros
                  </MenuItem>
                </NavLink>
                {(tecEng || geofi || publicGroup) && !(admin || typist) ? (
                  false
                ) : (
                  <div>
                    <NavLink to="/revisao" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={() => {
                          handleCloseIncidents();
                          setActive(1);
                        }}
                        className={styles.menuItemMap}
                      >
                        Revisão
                      </MenuItem>
                    </NavLink>

                    <NavLink to="/importador" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={() => {
                          handleCloseIncidents();
                          setActive(1);
                        }}
                        className={styles.menuItemMap}
                      >
                        Importador
                      </MenuItem>
                    </NavLink>

                    <NavLink to="/duplicidades" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={() => {
                          handleCloseIncidents();
                          setActive(1);
                        }}
                        className={styles.menuItemMap}
                      >
                        Duplicidades
                      </MenuItem>
                    </NavLink>
                    <NavLink to="/imprecisos" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={() => {
                          handleCloseIncidents();
                          setActive(1);
                        }}
                        className={styles.menuItemMap}
                      >
                        Imprecisos
                      </MenuItem>
                    </NavLink>
                  </div>
                )}
              </Menu>
              {(tecEng || geofi || typist || publicGroup || education) && !admin ? (
                false
              ) : (
                <Menu
                  id="simple-menu"
                  anchorEl={anchorIncidentsSAMU}
                  keepMounted
                  open={Boolean(anchorIncidentsSAMU)}
                  onClose={handleCloseIncidentsSAMU}
                  className={styles.menuRegisters}
                >
                  <NavLink to="/mapa/sinistrosSAMU" activeStyle={{ color: Colors.main }}>
                    <MenuItem
                      onClick={() => {
                        handleCloseIncidentsSAMU();
                        setActive(6);
                      }}
                      className={styles.menuItemMap}
                    >
                      Mapa
                    </MenuItem>
                  </NavLink>

                  <NavLink
                    to="/registros/sinistrosSAMU"
                    activeStyle={{ color: Colors.main }}
                  >
                    <MenuItem
                      onClick={() => {
                        handleCloseIncidentsSAMU();
                        setActive(6);
                      }}
                      className={styles.menuItemMap}
                    >
                      Registros
                    </MenuItem>
                  </NavLink>
                </Menu>
              )}

              {(publicGroup || education) && !(admin || typist || tecEng || geofi) ? (
                false
              ) : (
                <div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEngineering}
                    keepMounted
                    open={Boolean(anchorEngineering)}
                    onClose={handleCloseEngineering}
                    className={styles.menuRegisters}
                  >
                    <NavLink to="/mapa/engenharias" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={handleCloseEngineering}
                        className={styles.menuItemMap}
                      >
                        Mapa
                      </MenuItem>
                    </NavLink>

                    <NavLink
                      to="/registros/engenharias"
                      activeStyle={{ color: Colors.main }}
                    >
                      <MenuItem
                        onClick={handleCloseEngineering}
                        className={styles.menuItemMap}
                      >
                        Registros
                      </MenuItem>
                    </NavLink>
                  </Menu>
                </div>
              )}

              {(tecEng || publicGroup || education) && !(admin || typist || geofi) ? (
                false
              ) : (
                <div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorSurveillance}
                    keepMounted
                    open={Boolean(anchorSurveillance)}
                    onClose={handleCloseSurveillance}
                    className={styles.menuRegisters}
                  >
                    <NavLink
                      to="/mapa/fiscalizacoes"
                      activeStyle={{ color: Colors.main }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleCloseSurveillance();
                          setActive(3);
                        }}
                        className={styles.menuItemMap}
                      >
                        Mapa
                      </MenuItem>
                    </NavLink>

                    <NavLink
                      to="/registros/fiscalizacoes"
                      activeStyle={{ color: Colors.main }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleCloseSurveillance();
                          setActive(3);
                        }}
                        className={styles.menuItemMap}
                      >
                        Registros
                      </MenuItem>
                    </NavLink>
                  </Menu>
                </div>
              )}

              {/* EDUCAÇÃO */}
              {admin || education ? (
                <div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEducation}
                    keepMounted
                    open={Boolean(anchorEducation)}
                    onClose={handleCloseEducation}
                    className={styles.menuRegisters}
                  >
                    <NavLink to="/mapa/educacao" activeStyle={{ color: Colors.main }}>
                      <MenuItem
                        onClick={() => {
                          handleCloseEducation();
                          setActive(7);
                        }}
                        className={styles.menuItemMap}
                      >
                        Mapa
                      </MenuItem>
                    </NavLink>

                    <NavLink
                      to="/registros/educacao"
                      activeStyle={{ color: Colors.main }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleCloseEducation();
                          setActive(7);
                        }}
                        className={styles.menuItemMap}
                      >
                        Registros
                      </MenuItem>
                    </NavLink>
                  </Menu>
                </div>
              ) : (
                false
              )}
            </>
          ) : (
            <Box className={styles.appBarGrid2}>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                {/* <img src={LogoWhite} alt="Logo VIDA" className={styles.logo} /> */}
                <img
                  src={GovLogo}
                  alt="Logo Prefeitura de Fortaleza"
                  className={styles.govLogo}
                />
              </div>
            </Box>
          )}
        </Toolbar>

        <Drawer
          className={dStyles.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: dStyles.drawerPaper,
          }}
        >
          <div className={dStyles.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>
          <Divider />
          <Typography className={styles.typo}>VIDA</Typography>
          <Divider />

          <List className={dStyles.responsive}>
            <ListItem className={dStyles.button3}>Sinistros</ListItem>

            <ListItem button>
              <NavLink
                className={dStyles.button2}
                to="/mapa/sinistros"
                activeStyle={{ color: Colors.main }}
                onClick={handleDrawerClose}
              >
                Mapa
              </NavLink>
            </ListItem>
            <ListItem button>
              <NavLink
                className={dStyles.button2}
                to="/painel"
                activeStyle={{ color: Colors.main }}
                onClick={handleDrawerClose}
              >
                Painel
              </NavLink>
            </ListItem>
            <ListItem button>
              <NavLink
                className={dStyles.button2}
                to="/registros/sinistros"
                activeStyle={{ color: Colors.main }}
                onClick={handleDrawerClose}
              >
                Registros
              </NavLink>
            </ListItem>
            {publicGroup && !(admin || typist || tecEng || geofi || education) ? (
              false
            ) : (
              <>
                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/revisao"
                    activeStyle={{ color: Colors.main }}
                    onClick={handleDrawerClose}
                  >
                    Revisão
                  </NavLink>
                </ListItem>
                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/importador"
                    activeStyle={{ color: Colors.main }}
                    onClick={handleDrawerClose}
                  >
                    Importador
                  </NavLink>
                </ListItem>
              </>
            )}
            <Divider />
            {publicGroup && !(admin || geofi || typist || tecEng) ? (
              false
            ) : (
              <div>
                <ListItem className={dStyles.button3}>Engenharia</ListItem>

                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/mapa/engenharias"
                    activeStyle={{ color: Colors.main }}
                    onClick={() => {
                      handleDrawerClose();
                      setActive(2);
                    }}
                  >
                    Mapa
                  </NavLink>
                </ListItem>

                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/registros/engenharias"
                    activeStyle={{ color: Colors.main }}
                    onClick={() => {
                      handleDrawerClose();
                      setActive(2);
                    }}
                  >
                    Registros
                  </NavLink>
                </ListItem>

                <Divider />
              </div>
            )}
            {(tecEng || publicGroup) && !(admin || typist || geofi) ? (
              false
            ) : (
              <div>
                <ListItem className={dStyles.button3}>Fiscalização</ListItem>

                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/mapa/fiscalizacoes"
                    activeStyle={{ color: Colors.main }}
                    onClick={handleDrawerClose}
                  >
                    Mapa
                  </NavLink>
                </ListItem>

                <ListItem button>
                  <NavLink
                    className={dStyles.button2}
                    to="/registros/fiscalizacoes"
                    activeStyle={{ color: Colors.main }}
                    onClick={handleDrawerClose}
                  >
                    Registros
                  </NavLink>
                </ListItem>
                <Divider />
              </div>
            )}

            {(tecEng || geofi || typist || publicGroup) && !admin ? (
              false
            ) : (
              <div>
                <ListItem button>
                  <NavLink
                    to="/gerencia"
                    activeStyle={{ color: Colors.main }}
                    className={dStyles.button1}
                    onClick={handleDrawerClose}
                  >
                    Gerência
                  </NavLink>
                </ListItem>
                <Divider />
              </div>
            )}
            <ListItem button>
              <NavLink
                to="/minhaconta"
                activeStyle={{ color: Colors.main }}
                className={dStyles.button1}
                onClick={handleDrawerClose}
              >
                Minha Conta
              </NavLink>
            </ListItem>
            <Divider />
            <ListItem button>
              <Link to="/login" className={dStyles.button1} onClick={handleLogout}>
                Sair
              </Link>
            </ListItem>
          </List>
        </Drawer>
      </AppBar>
    </>
  );
};

export default Navbar;
